import {SecurityRequestBase} from '@/oauth/SecurityRequestBase';

export class Base extends SecurityRequestBase{
}
